/* tslint:disable */

/**
 */
export class ViewResponseUrl {
    url?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-response-url.ts